import * as types from "./actionTypes";

export const postDnataForm = (formName, formContent) => ({
  type: types.POST_DNATA_FORM,
  payload: { formName, formContent },
});

export const submitDnataForm = (dnataContent) => ({
  type: types.SUBMIT_DNATA_FORM,
  payload: { dnataContent },
});

export const dnataOnboardingSubmitted = () => ({
  type: types.DNATA_ONBOARDING_SUBMITTED,
});

export const submitDnataTest = (testAnswers) => ({
  type: types.SUBMIT_DNATA_TEST,
  payload: { testAnswers },
});

export const dnataTestSubmitted = (results) => ({
  type: types.DNATA_TEST_SUBMITTED,
  payload: results,
});

export const setDnataTestLoading = (isLoading) => {
  return {
    type: types.DNATA_TEST_IS_LOADING,
    payload: isLoading,
  };
};

export const submitDnataExtraForm = (formName, formContent) => ({
  type: types.SUBMIT_DNATA_EXTRA_FORM,
  payload: { formName, formContent },
});

export const setDnataExtraFormLoading = (formName) => ({
  type: types.SET_DNATA_EXTRA_FORM_LOADING,
  payload: formName,
});

export const uploadDnataPdf = (fileKey) => ({
  type: types.UPLOAD_DNATA_PDF,
  payload: fileKey,
});
